export default __webpack_public_path__ + "static/media/stars.d7d54f04.svg";